export const KOMATSU_MANUFACTURER_ID =
  process.env.REACT_APP_KOMATSU_MANUFACTURER_ID;
export const OTHER_MACHINE_TYPE_ID =
  process.env.REACT_APP_OTHER_MACHINE_TYPE_ID;
export const OTHER_MANUFACTURER_ID =
  process.env.REACT_APP_OTHER_MANUFACTURER_ID;
